import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/edit.svg'


const _hoisted_1 = { class: "mt-1" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["checked"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  alt: "Modifier"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Nouveau")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Search = _resolveComponent("Search")!

  return (_openBlock(), _createBlock(_component_Search, {
    title: _ctx.title || 'Liste',
    items: _ctx.items,
    "loading-key": _ctx.loadingKey,
    navigation: { nextPage: _ctx.nextPage, prevPage: _ctx.prevPage, toPage: _ctx.toPage, pages: _ctx.pagesCount },
    search: _ctx.search,
    "onItem:clicked": _ctx.onItemClicked,
    searchPlaceholder: _ctx.searchPlaceholder || 'Rechercher'
  }, _createSlots({
    item: _withCtx(({ uid, value }) => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.canDelete(value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: {"padding":"0.5rem","height":"100%"},
              onClick: _withModifiers(($event: any) => (_ctx.selectItem(uid)), ["stop"])
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.selectedItems.includes(uid),
                style: {"width":"1rem","height":"1rem"}
              }, null, 8, _hoisted_4)
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.canEdit(value))
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.canCreate)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "btn btn-primary",
            to: _ctx.newItemRoute
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.selectedItems.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn danger w-100",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteSelection && _ctx.deleteSelection(...args)))
          }, " Supprimer la selection "))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.headerText)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.headerText), 1)
          ])
        }
      : undefined
  ]), 1032, ["title", "items", "loading-key", "navigation", "search", "onItem:clicked", "searchPlaceholder"]))
}